import React from "react";

/* 
Transforms text strings containing links into arrays with injected components.
For example: 
    Input:          "My link is [link-text-here](http://www.google.com) the end." 
    Output:        ["My Link is", <a href="http://www.google.com">link-text-here</a>,"the end"] 
*/

const regex = /(\[[^[]+\]\([^\s\\]+\))/; // matches [link-text](/research/m/example)
export const injectLinks = (answer) => answer.split(regex).map((str, index) => parse(str, index));

const parse = (str, index) => {
  const text = str.match(/\[([^[]+)\]/); // matches [.*]
  const url = str.match(/\(([^\s\\]+)\)/); // matches (.*)
  return text && text[1] && url && url[1] ? createLink(text[1], url[1], index) : str;
};

const createLink = (text, url, index) => (
  <a key={index} href={url} className="text-primary">
    {text}
  </a>
);
